<div class="grid
  card card-s bg-gray-50
  py-24 px-32
  mb-24
  helix-lite-info"
  *ngIf="(navigationMenu.isHelixLiteAvailable$ | async) && !wasHelixLiteInfoHidden">
  <div class="grid-item grid grid-nowrap justify-content-between">
    <nz-collapse>
      <nz-collapse-panel
        [nzHeader]="collapseHeader"
        (nzActiveChange)="collapseChangeState($event)"
      >
        <div class="grid-item typography typography-body collapse-content">
          Заказ и оплата происходят онлайн, а сдать анализы можно в широкой сети партнерских медицинских центров.
          У Helix Lite нет затрат на аренду и сотрудников, поэтому мы предлагаем клиентам выгодные цены,
          выполняя анализы в лабораторных комплексах HELIX по высочайшим международным стандартам качества.
        </div>
      </nz-collapse-panel>
    </nz-collapse>
    <div class="grid-item controls">
      <div class="icon icon-16 icon-cross-1 typography gray-500"
        (click)="hideHelixLiteInfo()">
      </div>
    </div>
  </div>
  <div class="hidden-sm">
    <div class="
      grid grid-nowrap align-items-start gap-10
      typography typography-body
      full-width pl-4"
    >
      <ng-container *ngFor="let step of steps">
        <div class="grid grid-nowrap steps-item gap-10">
          <img [src]="step.image"/>
          <span [innerHTML]="step.title"></span>
        </div>
      </ng-container>
    </div>
  </div>
  <owl-carousel-o
    #carousel
    [options]="carouselOptionsHLProcessInfo"
    class="hidden block-sm full-width"
  >
    <ng-template 
      *ngFor="let step of steps; index as i" 
      carouselSlide
    >
      <div class="grid grid-nowrap justify-content-between steps-item">
        <div class="grid grid-nowrap gap-10">
          <img [src]="step.image"/>
          <span class="typography typography-caption" [innerHTML]="step.title"></span>
        </div>
        <span 
          [ngClass]="i == steps.length - 1 ? 'icon-check' : 'icon-chevron-right'"
          class="icon icon-16 ml-4 green-basic"
          (click)="nextCarouselSlide()"
        >
        </span>
      </div>
    </ng-template>
  </owl-carousel-o>
</div>

<ng-template #collapseHeader>
  <img [src]="logoImg" class="hidden-sm mr-24 logo-container" />
  <span 
    class="mt-8"
  >
    Почему в Helix Lite такие большие скидки?&nbsp;<span 
      [ngClass]="{'rotateToRight': isCollapseOpen$ | async}"
      class="icon icon-16 green-basic icon-chevron-right"
    ></span>
  </span>
</ng-template>
